"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    AGREE: 'agree',
    DISAGREE: 'disagree',
    COMPLETE: 'complete',
    RESOLVED: 'resolved',
    ABSENT: 'absent',
};
//# sourceMappingURL=attendanceStatus.js.map